////////EF 2.1 Schema
const twoOneSchema = {
  title: "2_1 Imported Electricity",
  cat: "2_1",
  catName: "cat2",
  progressiveOrderSwitch: {
    by: { level: 2, key: "sourceEFName" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 2,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        ////判斷上下階層關係
        value: "2_1",
      },
      showIf: { level: 1, key: "emissionFactorTypeId", ne: "2" },
      combineKey: 1,
    },
    ////////Location (Country)
    {
      key: "location",
      level: 3,
      type: "select",
      label: "Location (Country)",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "sourceEFName",
      },
      showIf: {
        level: 2,
        key: "sourceEFName",
        notEmpty: true,
      },
      combineKey: 2,
    },
    ////////State / City / Year (非自定義)
    {
      key: "emissionFactorId",
      level: 4,
      type: "select",
      label: "State / City / Year",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "location",
      },
      showIf: {
        level: 3,
        key: "location",
        notEmpty: true,
      },
      combineKey: 3,
    },
    ////////State / City / Year (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 4,
      type: "select",
      label: "Emission Factor Name",
      custom: true,
      optionsAPI: "cat2CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum:0,
    },
  ],
};

export default twoOneSchema;
